import React from 'react'
import { GetAIDescription, GetAIDescriptionFromDatabase } from '../Services/AIDescriptionService'
import { useConfig } from '../Providers/ConfigProvider'

const useAIDescription = () => {
    const { api } = useConfig()

    const handleGetAIDescription = async (product) => {
        try {
            let res = await GetAIDescription(api, product)
            return { desc: res.data, status: 0 }
        } catch (error) { //404 ponownie - 1 500 blad - 2
            if (error.response.status === 404) {
                return { desc: '', status: 1 }
            }
            console.log(error)
            return { desc: '', status: 2 }
        }
    }

    const handleGetAIDescriptionFromDatabase = async (index) => {
        try {
            let res = await GetAIDescriptionFromDatabase(api, index)
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    return {
        handleGetAIDescription,
        handleGetAIDescriptionFromDatabase,
    }
}

export default useAIDescription